import api from "@/lib/api";

// Persist before POST. Timeout/404 cannot establish non-delivery. Never replay
// automatically; only a user's explicit submission can send or save output.
const slot = (user, purpose) => `op_email_v1:${user?.id}:${user?.workspace_id || "personal"}:${purpose}`;
export function storedEmail(user, purpose) {
  const raw = localStorage.getItem(slot(user, purpose));
  if (!raw) return null;
  const r = JSON.parse(raw);
  if (!r || typeof r.id !== "string" || typeof r.state !== "string" || !r.parameters) throw new Error("Identité email locale illisible ; aucun nouvel envoi autorisé.");
  return r;
}
function write(user, purpose, record) { localStorage.setItem(slot(user, purpose), JSON.stringify(record)); }
const terminal = r => r?.state === "accepted" || r?.can_retry === true;
export async function refreshEmail(user, purpose) {
  const old = storedEmail(user, purpose);
  if (!old) return null;
  const { data } = await api.get(`/alerts/email/operations/${encodeURIComponent(old.id)}`);
  if (data?.id !== old.id || typeof data.state !== "string") throw new Error("État email invalide ; conserver l’identité.");
  if (storedEmail(user, purpose)?.id === old.id) write(user, purpose, { ...old, ...data });
  return data;
}
export async function submitEmail(user, purpose, path, parameters, { standard = false } = {}) {
  if (standard) return (await api.post(path)).data;
  const old = storedEmail(user, purpose);
  if (old && !terminal(old) && JSON.stringify(old.parameters) !== JSON.stringify(parameters)) throw new Error("Un envoi email non résolu possède d’autres paramètres. Consultez son état avant de changer la demande.");
  const record = old && !terminal(old) ? old : { id: crypto.randomUUID(), parameters, state: "pending" };
  write(user, purpose, record);
  try {
    const { data } = await api.post(path, null, { headers: { "Idempotency-Key": record.id } });
    if (storedEmail(user, purpose)?.id === record.id) write(user, purpose, { ...record, ...(data.email_operation || {}), id: record.id });
    return data;
  } catch (error) {
    try { await refreshEmail(user, purpose); } catch (_) { /* preserve uncertainty */ }
    throw error;
  }
}
